TS.ns('WL');

WL.contractGenerationViewModel = new Class({
    Extends: WL.documentBase,


    createProperties: function (config) {
        var me = this;
        
        me.parent(config);

        var itemDetailList = me.getDomainProperty('grdContractGenerationDetailList_Property');

        if (itemDetailList) {
            itemDetailList.on('cellBeginEdit', me.onItemsDetailGridSelectedBeginEdit);
            itemDetailList.on('cellValueChanged', me.onItemsDetailGridSelectedChanged);

            itemDetailList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.ContractGenerated == true || dataItem.IsAuto == false) {
                            row.addClass("grey_readonly_row");
                        }
                    }
                }
            }
        }
    }, 
    

    onItemsDetailGridSelectedBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        var itemList = owner.getDomainProperty('grdContractGenerationDetailList_Property');

        if (itemList.SelectedItem() === null) return;

        if (itemList.SelectedItem().ContractGenerated() || itemList.SelectedItem().IsAuto() === false) {
            e.preventDefault();
        }
    },

    onItemsDetailGridSelectedChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        var itemList = owner.getDomainProperty('grdContractGenerationDetailList_Property');

        if (itemList.SelectedItem() == null) return;

        if (e.fieldName == 'Selected' && itemList.SelectedItem().IsAuto()) {

            owner.performServerCommand({
                cmd: 'CheckAdditionalItemsForVehicle',
                submitModel: true,
                extraData: { SimulationNo: itemList.SelectedItem().SimulationNumber(), Selected: itemList.SelectedItem().Selected() },
                blockUI: false
            });
        }
    }

});
